/* global */
/* eslint no-unused-vars: 0 indent: 0 */

import { convertHMS } from "/Assets/js/utilities.js";
import vidyardEmbed from "@vidyard/embed-code";

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("[data-resources-by-product-page]")) {
        const resourcesByProductPage = new ResourcesByProductPage();
        resourcesByProductPage.init();

        if (vidyardEmbed) {
            resourcesByProductPage.updateVideoDurations();
        } else {
            document.addEventListener("onVidyardAPI", ({ detail: vyApi }) => resourcesByProductPage.init(vyApi));
        }
    }
});

class ResourcesByProductPage {
    constructor() {
        this.categorySelectionCntnr = null;
        this.productSelectCntnr = null;
        this.resultListingCntnr = null;
        this.defaultHeader = null;
    }

    init() {
        this.categorySelectionCntnr = document.querySelector("[data-category-selection]");
        this.productSelectCntnr = document.querySelector("[data-product-select]");
        this.resultListingCntnr = document.querySelector("[data-results-listing]");
        this.defaultHeader = document.querySelector("[data-default-header]");

        this.bindEvents();
    }

    bindEvents() {
        document.body.addEventListener("click", (e) => {
            if (e.target.closest("[data-product-category]")) {
                const category = e.target.closest("[data-product-category]").getAttribute("data-category-name");
                this.showProductList(category);
            } else if (e.target.closest("[data-select-new-product]")) {
                e.preventDefault();
                this.showCategorySelect();
            } else if (e.target.closest("[showall-items]")) {
                e.preventDefault();
                this.showAllItems(e);
            }
        });
    }

    showAllItems(e) {
        const rowsCntnr = e.target.closest(".foldable-content");
        rowsCntnr.querySelectorAll(".item-results").forEach(item => item.classList.remove("hide", "hidden-xs"));
        rowsCntnr.querySelector("[six-items]").classList.add("hide");
        rowsCntnr.querySelector("[showall-items]").classList.add("hide");
        rowsCntnr.querySelector("[all-items]").classList.remove("hide");
    }

    updateVideoDurations() {
        const videos = document.querySelectorAll("[data-prp-row=Videos] [data-video-source-url]");

        videos.forEach((obj) => {
            const url = obj.getAttribute("data-video-source-url");
            const pieces = url.split(/[/]+/);
            const videoId = pieces[pieces.length - 1].replace(/\?*$/, "");

            vidyardEmbed.api
                .getPlayerMetadata(videoId)
                .then((metadata) => {
                    const vidDuration = metadata.length_in_seconds;
                    obj.querySelector("[data-video-duration]").textContent = convertHMS(vidDuration);
                })
                .catch((e) => {
                    console.error("error fetching player metadata");
                });
        });
    }

    showCategorySelect() {
        this.resultListingCntnr.classList.add("hidden");
        this.productSelectCntnr.classList.add("hidden");
        this.defaultHeader.classList.remove("hidden");
        this.categorySelectionCntnr.classList.remove("hidden");
    }

    showProductList(category) {
        this.categorySelectionCntnr.classList.add("hidden");
        this.productSelectCntnr.querySelectorAll("[data-product-list]").forEach(list => list.classList.add("hidden"));
        this.productSelectCntnr.classList.remove("hidden");
        this.productSelectCntnr.querySelector(`[data-product-list='${category}']`).classList.remove("hidden");
    }
}